module.exports = __webpack_public_path__ + "img/banner5.e56b96b5.jpg";